import {
    Button,
    Grid,
} from "@mui/material";
import React, { useState } from "react";
import { useResponse } from "../utils/itemDataProvider";
import { useFieldArray, useForm } from "react-hook-form";
import { FormProvider, RHFFileField, RHFTextField, RHFSelectField } from "../common/hook-form";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { apiConstants, postGeneric } from "../common/constants";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import { useNavigate } from "../utils/Router";


function FullOrderReturn({ setFullOpen }) {
    const { response } = useResponse();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const { navigate } = useNavigate();
    function capitalizeFirstLetter(word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    const rvpOptions = response && Array.isArray(response.rvpList) && response.rvpList.length > 0
        ? response.rvpList.map(val => ({
            value: val,
            label: val.split(' ').map(capitalizeFirstLetter).join(' ')
        }))
        : [];

    const methods = useForm({
        defaultValues: {
            rvpReason: '',
            description: '',
            list: [
                {
                    file: null,
                },
            ],
        },
    });

    const { handleSubmit, control } = methods;
    const { fields, append, remove } = useFieldArray({
        control,
        name: "list",
    });

    const selectedRvpReason = methods.watch('rvpReason');
    const isOptionalImage = response?.optionalReturnImages?.includes(selectedRvpReason);
  
    const onSubmit = (data) => {
        setIsSubmitting(true)
        const payload = {
            id: response.id,
            userPhoneNumber: response.userPhoneNumber,
            awbNumber: response.awbNumber,
            rvpReason: data.rvpReason,
            isAllOrderReturn : true,
            isPartialReturn : false,
            itemData: response.itemData
                ?.filter((val) => val.isReturnAllowed)
                .map(item => ({
                    item: {
                        units: item.item.units,
                        sku_id: item.item.sku_id,
                    },
                    remainingItems: item.remainingItems,
                    alreadyReturnedUnits: item.alreadyReturnedUnits,
                    totalFwdUnits: item.totalFwdUnits,
                    rvpDesc: data.description,
                    skuRvpReason: data.rvpReason
                })),
            otp: {
                otpValue: response.otp.otpValue,
            },
        };
        let formData = new FormData();
        data?.list?.forEach((key, index) => {
            formData.append(`allImageCombinedRequestFile`, key?.file?.[0]);
        })
        formData.append('returnAndExchangeJson', JSON.stringify(payload))
        postGeneric(`${apiConstants.RETURN_DATA}`, formData).then((res) => {
            setIsSubmitting(false)
            if (res.status === 200) {
                postGeneric(`${apiConstants.SEND_RETURN_PLACED_MESSAGE}`, {
                    requestedItems: response?.itemData?.map(entry => ({
                        [entry.item?.sku_id]: entry.item?.units
                    })),
                    id: response?.id,
                    fromMerchant: response?.fromMerchant
                }).then((res) => {
                })
                enqueueSnackbar("Return Request Placed Successfully!", { variant: 'success' })
                setFullOpen(false);
                navigate('/')
            }
        }).catch((err) => {
            setIsSubmitting(false)
            enqueueSnackbar(err?.response?.data?.message || "Some error occurred!", { variant: 'error' })
            console.log(err);
            setFullOpen(false);
        });
    };

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} md={6}>
                    <RHFSelectField
                        name="rvpReason"
                        variant="filled"
                        label="Return Reason"
                        width='100%'
                        options={rvpOptions}
                        required={true}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <RHFTextField
                        label="Description"
                        name="description"
                        multiline
                        required={true}
                    />
                </Grid>
                {fields.map((field, index) => (
                    <React.Fragment key={field.id}>
                        <Grid container spacing={2} sx={{ mt: 1, ml: 0.6 }}>
                            <Grid item xs={12} md={6}>
                                <RHFFileField
                                    name={`list.${index}.file`}
                                    label={
                                        <>
                                            {`Upload Image ${index + 1}`}
                                            <span style={{ marginLeft: 10, fontSize: '0.8rem', color: 'grey' }}>
                                                ( jpg, jpeg, png )
                                            </span>
                                        </>
                                    }
                                    fileType={['.jpg', '.png', 'jpeg']}
                                    required={isOptionalImage ? false : true}
                                />
                            </Grid>
                            {fields.length !== 1 && (
                                <Grid item xs={4} md={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        onClick={() => remove(index)}
                                        color="error"
                                        variant="contained"
                                        startIcon={<RemoveCircleOutlineIcon />}
                                        size="small"
                                    >
                                        Remove
                                    </Button>
                                </Grid>
                            )}
                            {fields.length === index + 1 && (
                                <Grid item xs={4} md={1.5} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        onClick={() =>
                                            append({
                                                file: null,
                                            })
                                        }
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        size="small"
                                    >
                                        Add
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    </React.Fragment>
                ))}
                <Grid item xs={6} sx={{ ml: 0.5, mt: 2 }}>
                    <LoadingButton
                        loading={isSubmitting}
                        type="submit"
                        variant="contained"
                        size="small"
                    >
                        Submit
                    </LoadingButton>
                </Grid>
            </Grid>
        </FormProvider>
    );
}

export default FullOrderReturn;
